<script setup lang="ts">
import type { Emits, Props } from './type'

defineOptions({
  name: 'AppPageOpenButton',
})

defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<template>
  <button class="app-page-open-button" type="button" @click="emit('click')">
    <span class="app-page-open-button__icon" aria-hidden="true">
      <img class="app-page-open-button__icon-image" :src="icon" alt="" />
    </span>
    <span class="app-page-open-button__label">{{ label }}</span>
  </button>
</template>

<style scoped>
.app-page-open-button {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 0 24px 0 12px;
  cursor: pointer;
  color: #fff;
  background: var(--app-page-brand);
  border: 0;
  border-radius: 18px;
  font-size: 22.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  transition: transform var(--app-interaction-duration) var(--app-interaction-ease);
}

.app-page-open-button:hover,
.app-page-open-button:focus-visible {
  transform: scale(var(--app-interaction-scale-hover-subtle));
}

.app-page-open-button:active {
  transform: scale(var(--app-interaction-scale-active-subtle));
}

.app-page-open-button__icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 12px;
}

.app-page-open-button__icon-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.app-page-open-button__label {
  flex-shrink: 0;
  line-height: 1;
  white-space: nowrap;
}
</style>
